import UAParser from 'my-ua-parser';

// /**
//  * @deprecated
//  * @type {Map<string, Set<string>>}
//  */
// const validDeviceMap = new Map();
// validDeviceMap.set(
// 	'samsung',
// 	new Set([
// 		'sm-g960u',
// 		'sm-n960u',
// 		'sm-g950u',
// 		'sm-g965u',
// 		'sm-g955u',
// 		'sm-n950u',
// 		'sm-g975u',
// 		'sm-t580',
// 		'sm-t377w',
// 		'sm-t377a',
// 		'sm-t350',
// 	])
// );
// validDeviceMap.set('motorola', new Set(['moto e5 play']));
// validDeviceMap.set('lg', new Set(['lm-q710(fgn)', 'lg-q710al', 'k600']));
//
// validDeviceMap.set('amazon', new Set(['kfsuwi']));

/**
 * @param {*} value
 * @returns {number|*}
 */
const stringToNumber = (value) =>
	typeof value === 'string' && !Number.isNaN(value) ? Number(value) : value;

export class SemVersion {
	/**
	 * @type {string}
	 */
	#rawVersion;
	/**
	 * @type {number|undefined}
	 */
	#major;
	/**
	 * @type {number|undefined}
	 */
	#minor;
	/**
	 * @type {string|number|undefined}
	 */
	#patch;
	/**
	 * @type {string|number|undefined}
	 */
	#prerelease;
	/**
	 * @type {string|number|undefined}
	 */
	#build;

	/**
	 * @param {string|undefined} version
	 */
	constructor(version) {
		if (typeof version !== 'string') {
			console.error(`Invalid Version type: ${version}`);
			return;
		}

		this.#rawVersion = version.trim();

		this.#parseVersion();
	}

	get rawVersion() {
		return this.#rawVersion;
	}

	get major() {
		return this.#major;
	}

	get minor() {
		return this.#minor;
	}

	get patch() {
		return this.#patch;
	}

	get prerelease() {
		return this.#prerelease;
	}

	get build() {
		return this.#build;
	}

	#parseVersion() {
		const [major, minor, patch, prerelease, build, ...rest] = this.#rawVersion
			.split('.')
			.map((v) => v.trim());

		this.#major = stringToNumber(major);
		this.#minor = stringToNumber(minor);
		this.#patch = stringToNumber(patch);
		this.#prerelease = stringToNumber(prerelease);
		this.#build = stringToNumber(build);
	}
}

export class Environment {
	/**
	 * @type {UAParser.IBrowser}
	 */
	#browser;
	/**
	 * @type {UAParser.IOS}
	 */
	#os;
	/**
	 * @type {UAParser.IDevice}
	 */
	#device;
	/**
	 * @type {UAParser.IEngine}
	 */
	#engine;
	/**
	 * @type {string}
	 */
	#_ua;

	/**
	 * @type {SemVersion}
	 */
	#osVersion;

	/**
	 * @type {SemVersion}
	 */
	#browserVersion;

	/**
	 * @type {SemVersion}
	 */
	#engineVersion;

	/**
	 * @param {string} ua
	 */
	constructor(ua = navigator.userAgent) {
		const parser = new UAParser(ua);

		const result = parser.getResult();

		this.#_ua = result.ua;
		this.#browser = result.browser;
		this.#os = result.os;
		this.#device = result.device;
		this.#engine = result.engine;

		this.#osVersion = new SemVersion(this.#os.version);
		this.#browserVersion = new SemVersion(this.#browser?.version);
		this.#engineVersion = new SemVersion(this.#engine?.version);
	}

	/**
	 * @returns {string}
	 */
	get ua() {
		return this.#_ua;
	}

	/**
	 * @returns {string}
	 */
	get browserName() {
		return this.#browser.name;
	}

	/**
	 * @returns {boolean}
	 */
	get isFBApp() {
		return this.isAndroid && this.browserName === 'Facebook';
	}

	/**
	 * @returns {boolean}
	 */
	get isMobile() {
		return (
			typeof this.#device.type === 'string' &&
			['mobile', 'tablet'].includes(this.#device.type)
		);
	}

	/**
	 * @returns {boolean}
	 */
	get isAndroid() {
		return this.#os.name === 'Android';
	}

	/**
	 * @returns {boolean}
	 */
	get isIOs() {
		return this.#os.name === 'iOS';
	}

	get isSafari() {
		return ['Safari', 'Mobile Safari'].includes(this.browserName);
	}

	/**
	 * Check if running as a standalone PWA
	 * @returns {boolean}
	 */
	get isStandalonePWA() {
		return (
			window.matchMedia('(display-mode: standalone)').matches ||
			window.navigator.standalone === true
		);
	}

	/**
	 * @returns {boolean}
	 */
	get isNativeAndroid() {
		return this.isAndroid && this.browserName === 'Android Browser';
	}

	/**
	 * @returns {SemVersion}
	 */
	get osVersion() {
		return this.#osVersion;
	}

	/**
	 * @returns {SemVersion}
	 */
	get browserVersion() {
		return this.#browserVersion;
	}

	/**
	 * @returns {SemVersion}
	 */
	get engineVersion() {
		return this.#engineVersion;
	}

	/**
	 * @returns {boolean}
	 */
	get isValidIOs() {
		if (!this.isIOs) {
			return true;
		}

		const version = stringToNumber(this.osVersion.rawVersion);

		return version >= 13.5;
	}

	/**
	 * @returns {boolean}
	 */
	get isValidAndroid() {
		if (!this.isAndroid) {
			return true;
		}

		return this.osVersion.major >= 5;
	}
}

const hofEnv = new Environment();

export default hofEnv;
